import styled from "styled-components";

export const DisciplinaWrapper = styled.div`
  display: flex;
  padding: 16px;
  padding-bottom: 8px;

  .disciplinaForm {
    width: 100%;
  }
  
  .iconSelectWrapper {
    padding: 6px 5px 0 0;
  }

  .inputDescription {
    input {
      height: 42px;
    }
  }
`;

export const ButtonsWrapper = styled.div`

  .buttonCancel {
    border-radius: 5px !important;
    cursor: pointer !important;
  }

  .buttonSubmit {
    border-radius: 5px;
  }
`;
